<app-side-nav-companion-bar *ngIf="series !== undefined">
    <ng-container title>
        <h2 style="margin-bottom: 0px">
            <app-card-actionables [disabled]="actionInProgress" (actionHandler)="performAction($event)" [actions]="seriesActions" [labelBy]="series.name" iconClass="fa-ellipsis-v"></app-card-actionables>
            {{series?.name}}
        </h2>
    </ng-container>
    <ng-container subtitle *ngIf="series?.localizedName !== series?.name">
        <h6 style="margin-left:40px;" title="Localized Name">{{series?.localizedName}}</h6>
    </ng-container>
</app-side-nav-companion-bar>
<div class="container-fluid pt-2" *ngIf="series !== undefined">
    <div class="row mb-3">
        <div class="col-md-2 col-xs-4 col-sm-6 d-none d-sm-block">
            <app-image maxWidth="300px" [imageUrl]="seriesImage"></app-image>
        </div>
        <div class="col-md-10 col-xs-8 col-sm-6 mt-2">
            <div class="row g-0">
                <div class="col-auto">
                    <button class="btn btn-primary" (click)="read()">
                        <span>
                            <i class="fa {{showBook ? 'fa-book-open' : 'fa-book'}}"></i>
                        </span>
                        <span class="d-none d-sm-inline-block">&nbsp;{{(hasReadingProgress) ? 'Continue' : 'Read'}}</span>
                    </button>
                </div>
                <div class="col-auto ms-2" *ngIf="isAdmin">
                    <button class="btn btn-secondary" (click)="openEditSeriesModal()" title="Edit Series information">
                        <span>
                            <i class="fa fa-pen" aria-hidden="true"></i>
                        </span>
                    </button>
                </div>
                <div class="col-auto ms-2 d-none d-sm-block">
                    <div class="card-actions">
                        <app-card-actionables [disabled]="actionInProgress" (actionHandler)="performAction($event)" [actions]="seriesActions" [labelBy]="series.name" iconClass="fa-ellipsis-h" btnClass="btn-secondary"></app-card-actionables>
                    </div>
                </div>
                
                <div class="col-auto ms-2" *ngIf="isAdmin || hasDownloadingRole">
                    <button class="btn btn-secondary" (click)="downloadSeries()" title="Download Series" [disabled]="downloadInProgress">
                        <ng-container *ngIf="downloadInProgress; else notDownloading">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            <span class="visually-hidden">Downloading...</span>
                        </ng-container>
                        <ng-template #notDownloading>
                            <i class="fa fa-arrow-alt-circle-down" aria-hidden="true"></i>
                        </ng-template>
                    </button>
                </div>
                <div class="col-auto ms-2">
                    <ngb-rating class="rating-star" [(rate)]="series!.userRating" (rateChange)="updateRating($event)" (click)="promptToReview()"></ngb-rating>
                    <button *ngIf="series?.userRating || series.userRating" class="btn btn-sm btn-icon" (click)="openReviewModal(true)" placement="top" ngbTooltip="Edit Review" attr.aria-label="Edit Review"><i class="fa fa-pen" aria-hidden="true"></i></button>
                </div>
            </div>
            <div class="row g-0">
                <!-- TODO: This will be the first of reviews section. Reviews will show your plus other peoples reviews in media cards like Plex does and this will be below metadata -->
                <app-read-more class="user-review {{userReview ? 'mt-1' : ''}}" [text]="series?.userReview || ''" [maxLength]="250"></app-read-more>
            </div>
            <div *ngIf="seriesMetadata" class="mt-2">
                <app-series-metadata-detail [seriesMetadata]="seriesMetadata" [readingLists]="readingLists" [series]="series"></app-series-metadata-detail>
            </div>


        </div>
    </div>

    <ng-container>
        <app-bulk-operations [actionCallback]="bulkActionCallback"></app-bulk-operations>
        <ul ngbNav #nav="ngbNav" [(activeId)]="activeTabId" class="nav nav-tabs mb-2" [destroyOnHide]="false" (navChange)="onNavChange($event)">
            <li [ngbNavItem]="TabID.Specials" *ngIf="hasSpecials">
              <a ngbNavLink>Specials</a>
              <ng-template ngbNavContent>
                <div class="row g-0">
                    <ng-container *ngFor="let chapter of specials; let idx = index; trackBy: trackByChapterIdentity">
                        <app-card-item class="col-auto p-2" [entity]="chapter" [title]="chapter.title || chapter.range" (click)="openChapter(chapter)"
                        [imageUrl]="imageService.getChapterCoverImage(chapter.id)"
                        [read]="chapter.pagesRead" [total]="chapter.pages" [actions]="chapterActions" (selection)="bulkSelectionService.handleCardSelection('special', idx, chapters.length, $event)" [selected]="bulkSelectionService.isCardSelected('special', idx)" [allowSelection]="true"></app-card-item>
                    </ng-container>
                </div>
              </ng-template>
            </li>
            <li [ngbNavItem]="TabID.Storyline" *ngIf="libraryType !== LibraryType.Book && (volumes.length > 0 || chapters.length > 0)">
                <a ngbNavLink>Storyline</a>
                <ng-template ngbNavContent>
                    <div class="row g-0">
                        <ng-container *ngFor="let volume of volumes; let idx = index; trackBy: trackByVolumeIdentity">
                            <app-card-item class="col-auto p-2" *ngIf="volume.number != 0" [entity]="volume" [title]="volume.name" (click)="openVolume(volume)"
                            [imageUrl]="imageService.getVolumeCoverImage(volume.id) + '&offset=' + coverImageOffset"
                            [read]="volume.pagesRead" [total]="volume.pages" [actions]="volumeActions" (selection)="bulkSelectionService.handleCardSelection('volume', idx, volumes.length, $event)" [selected]="bulkSelectionService.isCardSelected('volume', idx)" [allowSelection]="true"></app-card-item>
                        </ng-container>
                          <ng-container *ngFor="let chapter of storyChapters; let idx = index; trackBy: trackByChapterIdentity">
                              <app-card-item class="col-auto p-2" *ngIf="!chapter.isSpecial" [entity]="chapter" [title]="chapter.title" (click)="openChapter(chapter)"
                              [imageUrl]="imageService.getChapterCoverImage(chapter.id) + '&offset=' + coverImageOffset"
                              [read]="chapter.pagesRead" [total]="chapter.pages" [actions]="chapterActions" (selection)="bulkSelectionService.handleCardSelection('chapter', idx, storyChapters.length, $event)" [selected]="bulkSelectionService.isCardSelected('chapter', idx)" [allowSelection]="true"></app-card-item>
                          </ng-container>
                    </div>
                </ng-template>
            </li>
            <li [ngbNavItem]="TabID.Volumes" *ngIf="volumes.length > 0">
                <a ngbNavLink>{{libraryType === LibraryType.Book ? 'Books': 'Volumes'}}</a>
                <ng-template ngbNavContent>
                    <div class="row g-0">
                          <ng-container *ngFor="let volume of volumes; let idx = index; trackBy: trackByVolumeIdentity">
                                  <app-card-item class="col-auto p-2" [entity]="volume" [title]="volume.name" (click)="openVolume(volume)"
                                  [imageUrl]="imageService.getVolumeCoverImage(volume.id) + '&offset=' + coverImageOffset"
                                  [read]="volume.pagesRead" [total]="volume.pages" [actions]="volumeActions" (selection)="bulkSelectionService.handleCardSelection('volume', idx, volumes.length, $event)" [selected]="bulkSelectionService.isCardSelected('volume', idx)" [allowSelection]="true"></app-card-item>
                          </ng-container>
                    </div>
                </ng-template>
              </li>
            <li [ngbNavItem]="TabID.Chapters" *ngIf="chapters.length > 0">
                <a ngbNavLink>{{utilityService.formatChapterName(libraryType) + 's'}}</a>
                <ng-template ngbNavContent>
                    <div class="row g-0">
                        <ng-container *ngFor="let chapter of chapters; let idx = index; trackBy: trackByChapterIdentity">
                            <app-card-item class="col-auto p-2" *ngIf="!chapter.isSpecial" [entity]="chapter" [title]="chapter.title" (click)="openChapter(chapter)"
                            [imageUrl]="imageService.getChapterCoverImage(chapter.id) + '&offset=' + coverImageOffset"
                            [read]="chapter.pagesRead" [total]="chapter.pages" [actions]="chapterActions" (selection)="bulkSelectionService.handleCardSelection('chapter', idx, chapters.length, $event)" [selected]="bulkSelectionService.isCardSelected('chapter', idx)" [allowSelection]="true"></app-card-item>
                        </ng-container>
                    </div>
                </ng-template>
            </li>
        </ul>
        <div [ngbNavOutlet]="nav"></div>
    </ng-container>

    <div class="mx-auto" *ngIf="isLoading" style="width: 200px;">
        <div class="spinner-border text-secondary loading" role="status">
            <span class="invisible">Loading...</span>
        </div>
    </div>
</div>
